export default __webpack_public_path__ + "static/media/divider.65c8a262.svg";